import { IRefundReqSchemaUI } from '@monetize/types/app';
import {
  getCurrencyDecimals,
  getFormattedDate,
  toDateOnly,
} from '@monetize/utils/core';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import {
  MCustomNumberInput,
  MFormField,
  MGridItem,
  MText,
  MTextarea,
} from '../Monetize';

const currentDate = getFormattedDate(
  toDateOnly(new Date(), 'userTimezone'),
  'MMM dd, yyyy',
);

interface RefundCreateFormProps {
  isLoading: boolean;
  control: Control<IRefundReqSchemaUI>;
  errors: FieldErrors<IRefundReqSchemaUI>;
  currency: string | undefined;
}

export const RefundCreateForm = ({
  isLoading,
  control,
  errors,
  currency,
}: RefundCreateFormProps) => {
  return (
    <>
      <MGridItem colSpan={6}>
        <MFormField error={errors.refundAmount} label="Amount" isRequired>
          <Controller
            name="refundAmount"
            control={control}
            render={({ field: { onChange, ...field } }) => (
              <MCustomNumberInput
                isDisabled={isLoading}
                precision={getCurrencyDecimals(currency)}
                inputMode="decimal"
                onChange={(value) => onChange(value)}
                {...field}
              />
            )}
          />
        </MFormField>
      </MGridItem>
      <MGridItem colSpan={6}>
        <MFormField label="Refund Date">
          <MText lineHeight={2.2}>{currentDate}</MText>
        </MFormField>
      </MGridItem>
      <MGridItem colSpan={12}>
        <MFormField error={errors.description} label="Reason" isRequired>
          <MText mb={2} fontSize={12}>
            This will be listed on the Refund document, which may be visible to
            end customers.
          </MText>
          <Controller
            name="description"
            control={control}
            render={({ field: { onChange, ...field } }) => (
              <MTextarea
                isDisabled={isLoading}
                rows={1}
                placeholder="Reasons for refund"
                onChange={(value) => onChange(value)}
                {...field}
              />
            )}
          />
        </MFormField>
      </MGridItem>
    </>
  );
};
